// Native VoIP/CallKit integration (Capacitor iOS)
import { Capacitor, registerPlugin } from '@capacitor/core';
import { api } from '@/App';

const AdeCall = Capacitor.isNativePlatform() ? registerPlugin('AdeCall') : null;
let initialized = false;

const handleAction = (action, callId) => {
  if (!callId) return;
  if (action === 'answer') {
    window.dispatchEvent(new CustomEvent('ade-native-answer', { detail: { callId } }));
  } else if (action === 'decline') {
    api.post(`/calls/${callId}/decline`).catch(() => {});
    window.dispatchEvent(new CustomEvent('ade-native-decline', { detail: { callId } }));
  }
};

export async function initializeNativeCall() {
  if (initialized || !AdeCall) return;
  initialized = true;
  try {
    await AdeCall.addListener('voipToken', async ({ token }) => {
      if (!token) return;
      try {
        await api.post('/push/native-token', { token, platform: 'ios-voip' });
      } catch (e) { console.error('VoIP token registration failed', e); }
    });

    await AdeCall.addListener('callAction', ({ action, callId }) => handleAction(action, callId));

    // Cold start: token + pending CallKit action (answered/declined while app was closed)
    const { token } = await AdeCall.getVoipToken();
    if (token) {
      api.post('/push/native-token', { token, platform: 'ios-voip' }).catch(() => {});
    }
    const pending = await AdeCall.getPendingAction();
    if (pending?.action) handleAction(pending.action, pending.callId);
  } catch (e) {
    console.error('Native call init failed', e);
  }
}

export function endNativeCall(callId) {
  if (!AdeCall || !callId) return;
  AdeCall.endNativeCall({ callId }).catch(() => {});
}

export const isNativeCallPlatform = () => !!AdeCall;
